import request from "@/utils/request";
import { fileService } from "@/api/common/file-utils";

export default {
  findDqmpListPage: (param) => {
    return request({
      url: `/dqmp/findListPage`,
      method: "post",
      data: param,
    });
  },
  getMonth: (param) => {
    return request({
      url:param?`/dqmp/getMonth?includeCurrent=true`:`/dqmp/getMonth`,
      method: "get",
    });
  },
  updateBatchDqmp: (type, param) => {
    return request({
      url: `/dqmp/${type}`,
      method: "post",
      data: param,
    });
  },
  dqmpDownload: (param) => {
    return request({
      url: `/dqmp/dqmpDownload`,
      data: param,
      method: "post",
      responseType: "blob",
      fullResponse: true,
    });
  },
  exportList: (param) => {
    return request({
      url: `/qspiFacilityMonthOutbound/dataListDownload`,
      data: param,
      method: "post",
      responseType: "blob",
      fullResponse: true,
    }).then((resp)=>{
      console.log("下载的文件名==",resp)
      fileService.respToFile(resp, 'DC月度各Facility发货量.xlsx');
    });
  },
};
